import React from 'react';
import {generateAnalyticsId} from '../../utils/analytics';
import Widget from './Widget';

const WidgetContainer = ({analytics, hints, widgets, startDate, endDate, instanceType, updateSurveyStatsFromWidget}) => (
    <div className="widget-container">
        {widgets.map((w, index) => <Widget key={index} analytics={analytics[generateAnalyticsId(w)]} hints={hints} instanceType={instanceType}
            updateSurveyStatsFromWidget={updateSurveyStatsFromWidget} {...w} />)}
    </div>
);

export default WidgetContainer;
